import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchRecallAuditEvent, fetchRecallAuditLog} from 'api/recallAudit';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {RecallAuditEntry, RecallAuditPage} from 'types/recall-audit';

const domain = rootDomain.createDomain('RecallAuditDomain');

export const fetchRecallAuditLogFx = domain.createEffect({
    name: 'fetchRecallAuditLogFx',
    handler: fetchRecallAuditLog,
});

export const fetchRecallAuditEventFx = domain.createEffect({
    name: 'fetchRecallAuditEventFx',
    handler: fetchRecallAuditEvent,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    Gate,
    tableStateChanged,
    stateReset,
} = createGridTableModel({domain});

export const data$ = domain.createStore<RecallAuditPage | null>(null);
export const detailData$ = domain.createStore<RecallAuditEntry | null>(null);
export const DetailGate = createGate<{eventId: string}>('RecallAuditDetailGate');

export const tableState$ = combine({
    data: data$,
    filters: filters$,
    sortings: sortings$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    isLoading: fetchRecallAuditLogFx.pending,
});

export const detailState$ = combine({
    data: detailData$,
    isLoading: fetchRecallAuditEventFx.pending,
});
